import { all, put, call, select, takeEvery, takeLatest, actionChannel } from 'redux-saga/effects';
import { initMediaPopup, initBrowseStream, initPostStream, initGallectionDeviationStream, initGallectionStream, initCustomSetDeviationStream, fetchMoreGallections, fetchMoreBrowseDeviations, fetchMorePosts, fetchMoreGallectionDeviations, fetchMoreCommissions, changeCurrentMediaSource, setSearchQuery, setCurrentFolderId, unsetCurrentFolderId, deselectAll, addDeviations, copyDeviations, moveDeviations, removeDeviations, removeGallection, makeDeviationCurrentGallectionCover, moveGallectionToPosition, moveGallection, moveDeviationToPosition, setGallectionName, setGallectionDescription, setGallectionPrice, setGallectionCover, createGallection, onSelectableItemClick, replaceSelect, toggleAppendSelect, uploadFile, uploadFiles, reloadStashStream, setCurrentSubfolderId, unsetCurrentSubfolderId, initTierStream, fetchMoreTiers, initTierDeviationStream, initCommissionStream, fetchMoreTierDeviations, setCurrentTierId, unsetCurrentTierId, labelAs, initSingleDeviationByLookupStream } from '../actions';
import { getSelectionLimit } from '../selectors';
import { selectors, withOffset } from '../../Stream';
import { MEDIA_POPUP_POLL_STREAM_ID, MEDIA_POPUP_STATUS_STREAM_ID, MEDIA_POPUP_JOURNAL_STREAM_ID, MEDIA_POPUP_POSTS_STREAM_ID, MEDIA_POPUP_BROWSE_DEVIATION_STREAM_ID, MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID, MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP, MEDIA_POPUP_GALLECTION_STREAM_GROUP, MEDIA_POPUP_TIER_STREAM_ID, MEDIA_POPUP_TIER_DEVIATION_STREAM_GROUP, MEDIA_POPUP_COMMISSION_STREAM_ID } from '../constants';
import initGallectionStreamHandler from './initGallectionStream';
import initPostStreamHandler from './initPostStream';
import initBrowseStreamHandler from './initBrowseStream';
import initTierStreamHandler from './initTierStream';
import initCommissionStreamHandler from './initCommissionStream';
import initTierDeviationStreamHandler from './initTierDeviationStream';
import initGallectionDeviationStreamHandler from './initGallectionDeviationStream';
import initCustomSetDeviationStreamHandler from './initCustomSetDeviationStream';
import initSingleDeviationByLookupStreamHandler from './initSingleDeviationByLookupStream';
import gallectionDeviationStreamFetch from './gallectionDeviationStreamFetch';
import tierDeviationStreamFetch from './tierDeviationStreamFetch';
import postStreamFetch from './postStreamFetch';
import browseDeviationStreamFetch from './browseDeviationStreamFetch';
import tierStreamFetch from './tierStreamFetch';
import commissionStreamFetch from './commissionStreamFetch';
import gallectionStreamFetchHandler from './gallectionStreamFetch';
import copyDeviationsHandler from './copyDeviations';
import moveDeviationsHandler from './moveDeviations';
import removeDeviationsHandler from './removeDeviations';
import addDeviationsHandler from './addDeviations';
import removeGallectionHandler from './removeGallection';
import initMediaPopupHandler from './initMediaPopup';
import changeCurrentMediaSourceHandler from './changeCurrentMediaSource';
import setSearchQueryHandler from './setSearchQuery';
import setCurrentFolderIdHandler from './setCurrentFolderId';
import fetchMoreGallectionsHandler from './fetchMoreGallections';
import fetchMoreGallectionDeviationsHandler from './fetchMoreGallectionDeviations';
import fetchMoreBrowseDeviationsHandler from './fetchMoreBrowseDeviations';
import fetchMorePostsHandler from './fetchMorePosts';
import fetchMoreTiersHandler from './fetchMoreTiers';
import fetchMoreTierDeviationsHandler from './fetchMoreTierDeviations';
import fetchMoreCommissionsHandler from './fetchMoreCommissions';
import createGallectionHandler from './createGallection';
import setGallectionNameHandler from './setGallectionName';
import setGallectionPriceHandler from './setGallectionPrice';
import saveChangedGallectionNameHandler from './saveChangedGallectionName';
import saveChangedGallectionPriceHandler from './saveChangedGallectionPrice';
import setGallectionDescriptionHandler from './setGallectionDescription';
import saveChangedGallectionDescriptionHandler from './saveChangedGallectionDescription';
import makeDeviationGallectionCoverHandler from './makeDeviationGallectionCover';
import moveGallectionToPositionHandler from './moveGallectionToPosition';
import moveGallectionHandler from './moveGallection';
import moveDeviationToPositionHandler from './moveDeviationToPosition';
import uploadFileHandler from './uploadFile';
import uploadFilesHandler from './uploadFiles';
import reloadStashStreamHandler from './reloadStashStream';
import { setGallectionCoverActionHandler } from './setGallectionCover';
import labelAsHandler from './labelAs';
function* streamFetchHandler(action) {
    const { streamId } = action;
    switch(streamId){
        case MEDIA_POPUP_BROWSE_DEVIATION_STREAM_ID:
        case MEDIA_POPUP_BROWSE_SEARCH_DEVIATION_STREAM_ID:
            return yield call(browseDeviationStreamFetch, action);
        case MEDIA_POPUP_POLL_STREAM_ID:
        case MEDIA_POPUP_STATUS_STREAM_ID:
        case MEDIA_POPUP_JOURNAL_STREAM_ID:
        case MEDIA_POPUP_POSTS_STREAM_ID:
            return yield call(postStreamFetch, action);
        case MEDIA_POPUP_TIER_STREAM_ID:
            return yield call(tierStreamFetch, action);
        case MEDIA_POPUP_COMMISSION_STREAM_ID:
            return yield call(commissionStreamFetch, action);
        default:
    }
    const groupId = yield select(selectors.getGroupId, streamId);
    switch(groupId){
        case MEDIA_POPUP_GALLECTION_STREAM_GROUP:
            return yield call(gallectionStreamFetchHandler, action);
        case MEDIA_POPUP_GALLECTION_DEVIATION_STREAM_GROUP:
            return yield call(gallectionDeviationStreamFetch, action);
        case MEDIA_POPUP_TIER_DEVIATION_STREAM_GROUP:
            return yield call(tierDeviationStreamFetch, action);
        default:
    }
}
export default function* saga() {
    const moveDeviationToPositionChan = yield actionChannel(moveDeviationToPosition);
    yield all([
        takeEvery(initMediaPopup, initMediaPopupHandler),
        takeEvery(initPostStream, initPostStreamHandler),
        takeEvery(initBrowseStream, initBrowseStreamHandler),
        takeEvery(initTierStream, initTierStreamHandler),
        takeEvery(initCommissionStream, initCommissionStreamHandler),
        takeEvery(initTierDeviationStream, initTierDeviationStreamHandler),
        takeEvery(initGallectionStream, initGallectionStreamHandler),
        takeEvery(initCustomSetDeviationStream, initCustomSetDeviationStreamHandler),
        takeEvery(initSingleDeviationByLookupStream, initSingleDeviationByLookupStreamHandler),
        takeEvery(fetchMoreGallections, fetchMoreGallectionsHandler),
        takeEvery(fetchMoreBrowseDeviations, fetchMoreBrowseDeviationsHandler),
        takeEvery(fetchMorePosts, fetchMorePostsHandler),
        takeEvery(fetchMoreTiers, fetchMoreTiersHandler),
        takeEvery(fetchMoreCommissions, fetchMoreCommissionsHandler),
        takeEvery(fetchMoreTierDeviations, fetchMoreTierDeviationsHandler),
        takeEvery(fetchMoreGallectionDeviations, fetchMoreGallectionDeviationsHandler),
        takeEvery(addDeviations, addDeviationsHandler),
        takeEvery(copyDeviations, copyDeviationsHandler),
        takeEvery(moveDeviations, moveDeviationsHandler),
        takeEvery(removeDeviations, removeDeviationsHandler),
        takeEvery(createGallection, createGallectionHandler),
        takeEvery(removeGallection, removeGallectionHandler),
        takeEvery(setGallectionName, setGallectionNameHandler),
        takeLatest(setGallectionName, saveChangedGallectionNameHandler),
        takeEvery(setGallectionDescription, setGallectionDescriptionHandler),
        takeEvery(setGallectionCover, setGallectionCoverActionHandler),
        takeLatest(setGallectionDescription, saveChangedGallectionDescriptionHandler),
        takeEvery(setGallectionPrice, setGallectionPriceHandler),
        takeLatest(setGallectionPrice, saveChangedGallectionPriceHandler),
        takeEvery(moveGallection, moveGallectionHandler),
        takeEvery(moveGallectionToPosition, moveGallectionToPositionHandler),
        takeEvery(moveDeviationToPositionChan, moveDeviationToPositionHandler),
        takeEvery(makeDeviationCurrentGallectionCover, makeDeviationGallectionCoverHandler),
        takeEvery(initGallectionDeviationStream, initGallectionDeviationStreamHandler),
        takeEvery(withOffset.actions.STREAM__WITH_OFFSET__FETCH, streamFetchHandler),
        takeEvery(changeCurrentMediaSource, changeCurrentMediaSourceHandler),
        takeEvery(setSearchQuery, setSearchQueryHandler),
        takeEvery(setCurrentFolderId, setCurrentFolderIdHandler),
        takeEvery(setCurrentSubfolderId, function*() {
            yield put(initGallectionDeviationStream());
        }),
        takeEvery(setCurrentTierId, function*() {
            yield put(initTierDeviationStream());
        }),
        takeEvery([
            unsetCurrentFolderId,
            unsetCurrentSubfolderId,
            unsetCurrentTierId,
            setCurrentFolderId,
            setCurrentSubfolderId
        ], function*() {
            yield put(deselectAll());
        }),
        takeEvery(onSelectableItemClick, function*(action) {
            const selectionLimit = yield select(getSelectionLimit);
            if (selectionLimit === 1) {
                yield put(replaceSelect(action.payload));
            } else {
                yield put(toggleAppendSelect(action.payload));
            }
        }),
        takeEvery(uploadFile, uploadFileHandler),
        takeEvery(uploadFiles, uploadFilesHandler),
        takeLatest(reloadStashStream, reloadStashStreamHandler),
        takeLatest(labelAs, labelAsHandler)
    ]);
}
